import { render, staticRenderFns } from "./titleEditor.vue?vue&type=template&id=537bc535&scoped=true&"
import script from "./titleEditor.vue?vue&type=script&lang=js&"
export * from "./titleEditor.vue?vue&type=script&lang=js&"
import style0 from "./titleEditor.vue?vue&type=style&index=0&id=537bc535&scoped=true&lang=scss&"
import style1 from "./titleEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537bc535",
  null
  
)

export default component.exports